window.OnlineServicesParticulieren = window.OnlineServicesParticulieren || {};
(function(OnlineServicesParticulieren) {
  "use strict";

  function isIE() {
    var ua = navigator.userAgent;
    /* MSIE used to detect old browsers and Trident used to newer ones*/
    return ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
  }

  OnlineServicesParticulieren.IsIE = isIE;
})(window.OnlineServicesParticulieren);
